import { useFormContext } from 'react-hook-form';
import React, { useCallback, useEffect, useState } from 'react';
import {
  CALCULATION_BRANCH_STRING_RESULT_MAX_LENGTH,
  CalculationResultType,
  checkArithmeticExpression,
  VariableType,
} from '../../../../../services/common/CalculatorUtils';
import CalculatorStandardInput from '../calculatorInputs/CalculatorStandardInput';
import i18next from 'i18next';

const ResultValueField = ({ fieldName, resultType, disabled = false }) => {
  const formMethods = useFormContext();
  const {
    setError,
    clearErrors
  } = formMethods;

  const [authorizedArguments, setAuthorizedArguments] = useState([]);

  const validateArithmeticExpression = useCallback((expr) => {
    return checkArithmeticExpression(expr, authorizedArguments);
  }, [authorizedArguments]);

  useEffect(() => {
    setAuthorizedArguments(formMethods.getValues(`variables`)
      ?.filter(variable => VariableType.RESULT_FORMULA_ARGUMENT === variable.type)
      ?.map(variable => variable.name)
    );
  }, [formMethods, setAuthorizedArguments]);

  return (
    <CalculatorStandardInput
      fieldName={fieldName}
      placeholder={i18next.t("calculator.dialog.create.placeholder.resultValue")}
      isRequired={true}
      style={{ background: "white", width: "330px" }}
      disabled={disabled}
      validate={(value) => {
        let errorMsg = null;

        switch (resultType) {
          case CalculationResultType.STRING:
            if (value.length > CALCULATION_BRANCH_STRING_RESULT_MAX_LENGTH) {
              errorMsg = i18next.t(
                "calculator.errors.resultMaxLengthExceeded",
                {
                  length: CALCULATION_BRANCH_STRING_RESULT_MAX_LENGTH,
                }
              );
              setError(fieldName, { type: "manual", message: errorMsg });
            } else {
              clearErrors(fieldName);
            }
            break;

          case CalculationResultType.ARITHMETIC_FORMULA_OUTPUT:
            errorMsg = validateArithmeticExpression(value);

            if (errorMsg !== ``) {
              errorMsg = i18next.t(`calculator.errors.${errorMsg}`);
              setError(fieldName, { type: "manual", message: errorMsg });
            } else {
              errorMsg = null;
              clearErrors(fieldName);
            }
            break;

          default:
            break;
        }

        return errorMsg;
      }}
      onClick={(e) => e.stopPropagation()}
    />
  );
}

export default ResultValueField;